interface ColumnsIconProps {
  className?: string;
}

/**
 * Three vertical bars, reading as table columns. Matches the house icon style:
 * 20x20, currentColor stroke at 1.25 — same as FilterIcon beside it in the toolbar.
 */
export const ColumnsIcon = ({ className }: ColumnsIconProps) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="2.5"
      y="3.33"
      width="15"
      height="13.33"
      rx="1.5"
      stroke="currentColor"
      strokeWidth="1.25"
    />
    <path
      d="M7.5 3.33V16.67M12.5 3.33V16.67"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
  </svg>
);
